import { connect } from 'react-redux';
import compose from 'lodash/fp/compose';

import { selectRequestError, selectRequestStatus } from '@/store/reducers/api-requests/selectors';
import {
  createNewShippingAddress,
  deleteShippingAddresses,
  updateShippingAddresses,
} from '@/store/reducers/shipping-addreses/actions';
import { selectNewShippingAddresses } from '@/store/reducers/shipping-addreses/selectors';
import { AppState } from '@/types';

import { AddressBookModal as Component } from './AddressBookModal';

const mapStateToProps = (state: AppState) => ({
  shippingAddresses: selectNewShippingAddresses(state),
  createAddressError: selectRequestError(state, 'shippingAddresses|createNewShippingAddress'),
  updateAddressError: selectRequestError(state, 'shippingAddresses|updateShippingAddress'),
  deleteAddressError: selectRequestError(state, 'shippingAddresses|deleteShippingAddress'),
  loadingFetch: selectRequestStatus(state, 'shippingAddresses|fetchShippingAddresses'),
  loadingCreate: selectRequestStatus(state, 'shippingAddresses|createNewShippingAddress'),
  loadingUpdate: selectRequestStatus(state, 'shippingAddresses|updateShippingAddress'),
  loadingDelete: selectRequestStatus(state, 'shippingAddresses|deleteShippingAddress'),
});

const mapActionsToProps = {
  createShippingAddress: createNewShippingAddress,
  updateShippingAddress: updateShippingAddresses,
  deleteShippingAddress: deleteShippingAddresses,
};

export const AddressBookModal = compose(
  connect(mapStateToProps, mapActionsToProps, null, { forwardRef: true }),
)(Component);
